// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_hc-0";
export var optionCard = "_hc-1";